import { getValue } from "@mui/system";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Button } from "@mui/material";
import client from "../../../Common/Client/Client";

const SeatLayout = React.memo(
  ({ layout, selectedSeat, selectedDate, isPending, seatLockData }) => {
    const [filteredSeatLayout, setFilteredSeatLayout] = useState([]);
    const [lockSeat, setLockSeat] = useState([]);

    console.log(lockSeat);
    

    const seatFilter = () => {
      const filteredSeat = layout.filter(
        (eachSeat) => !selectedSeat.includes(eachSeat._id),
      );

      let forSelect = filteredSeat.map((each) => ({
        label: `Seat Number:${each.number}`,
        value: `${each._id}`,
      }));

      setFilteredSeatLayout(forSelect);
    };

    useEffect(() => {
      seatFilter();
    }, [layout, selectedSeat]);

    const selectSeatLock = async () => {
      try {
        if (lockSeat.length <= 0) {
          alert("please select seat to lock");
          return false;
        }
        const response = await client.post(
          "/admin-lock/lock",
          { lockSeat, selectedDate },
          { withCredentials: true },
        );
        console.log(response);
        if (response.status === 200) {
          alert("Seat Locked Successfully");
          seatLockData();
          setLockSeat([])
        }
      } catch (error) {
        console.log(error);
        alert(error.response.data.message);
      }
    };

    return (
      <>
        {isPending ? (
          <p className="my-4">Loading...</p>
        ) : (
          <div className="">
            <Select
              isMulti
              className="basic-multi-select"
              classNamePrefix="select the seat"
              options={filteredSeatLayout}
              onChange={setLockSeat}
              value={lockSeat}
              closeMenuOnSelect={false}
              blurInputOnSelect={false}
            />
            <div style={{textAlign:"right"}}>
              <Button
                variant="contained"
                className=""
                onClick={selectSeatLock}
                // disabled={open}
                style={{
                  backgroundColor: "#e89e25 ",
                  marginTop: "10px",
                }}
              >
                Lock Seat
              </Button>
            </div>
          </div>
        )}
      </>
    );
  },
);

export default SeatLayout;
